var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2264 30.2338L19.8334 20.8408C19.0834 21.4798 18.2209 21.9743 17.2459 22.3243C16.2709 22.6743 15.2909 22.8493 14.3059 22.8493C11.9039 22.8493 9.87094 22.0178 8.20694 20.3548C6.54294 18.6918 5.71094 16.6593 5.71094 14.2573C5.71094 11.8553 6.54194 9.82175 8.20394 8.15675C9.86594 6.49175 11.8979 5.65825 14.2999 5.65625C16.7019 5.65425 18.7359 6.48625 20.4019 8.15225C22.0679 9.81825 22.9014 11.8518 22.9024 14.2528C22.9024 15.2948 22.7179 16.3033 22.3489 17.2783C21.9799 18.2533 21.4949 19.0873 20.8939 19.7803L30.2869 29.1718L29.2264 30.2338ZM14.3059 21.3478C16.2959 21.3478 17.9764 20.6628 19.3474 19.2928C20.7184 17.9228 21.4034 16.2423 21.4024 14.2513C21.4014 12.2603 20.7164 10.5803 19.3474 9.21125C17.9784 7.84225 16.2984 7.15725 14.3074 7.15625C12.3164 7.15525 10.6359 7.84025 9.26594 9.21125C7.89594 10.5823 7.21094 12.2623 7.21094 14.2513C7.21094 16.2403 7.89594 17.9203 9.26594 19.2913C10.6359 20.6623 12.3159 21.3488 14.3059 21.3478Z",
    fill: "#FEFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.eb8cc68d5a4e20d3a9324424eeb0050c.svg";
export { ForwardRef as ReactComponent };